import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const inputVariants = cva(
  'file:text-foreground placeholder:text-ss-neutral-400 selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:bg-ss-neutral-50 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm  dark:aria-invalid:ring-ss-text-critical-200 aria-invalid:border-ss-critical-200 aria-invalid:ring-red-200  dark:border-ss-neutral-700 dark:bg-input dark:text-foreground dark:aria-invalid:border-ss-text-critical border-ss-neutral-100 active:border-ss-blue-500 hover:border-ss-blue-500 focus:border-ss-blue-500 focus-visible:border-ss-blue-500 focus-visible:ring-ss-blue-500/20 dark:focus-visible:ring-ss-blue-500/40 dark:hover:border-ss-blue-500 dark:active:border-ss-blue-500 dark:focus:border-ss-blue-500 dark:focus-visible:border-ss-blue-500 focus-visible:border-ss-blue-400 focus-visible:ring-ring/50 focus-visible:ring-[4px]  dark:focus-visible:ring-ss-blue-800/50 ',
  {
    variants: {
      inputSize: {
        default: 'h-9 px-3 py-1',
        small: 'h-9 px-3 py-2',
        medium: 'h-10 px-3 py-2',
        large: 'h-11 px-[14px] py-[10px]',
      },
    },
    defaultVariants: {
      inputSize: 'default',
    },
  }
)

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputSize, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ inputSize, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
